import React from 'react';
import { Link } from 'react-router-dom';

const C = { border:'rgba(0,255,255,0.08)', muted:'rgba(248,249,250,0.72)', muted2:'rgba(248,249,250,0.72)', cyan:'#00FFFF' };

export default function MarketingFooter() {
  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <div style={s.top} className="scq-footer">
          <div style={s.brand}>
            <div style={s.logo}>SenseCritiq</div>
            <div style={s.tagline}>Map User Emotion. Reach Certainty.</div>
          </div>
          <div style={s.cols}>
            <div style={s.col}>
              <div style={s.colHead}>Product</div>
              <Link to="/how-it-works" style={s.colLink}>How it works</Link>
              <Link to="/features" style={s.colLink}>Features</Link>
              <Link to="/pricing" style={s.colLink}>Pricing</Link>
              <Link to="/researchers" style={s.colLink}>For researchers</Link>
            </div>
            <div style={s.col}>
              <div style={s.colHead}>Account</div>
              <Link to="/sign-up" style={s.colLink}>Get started</Link>
              <Link to="/sign-in" style={s.colLink}>Sign in</Link>
              <Link to="/dashboard" style={s.colLink}>Dashboard</Link>
            </div>
            <div style={s.col}>
              <div style={s.colHead}>Company</div>
              <a href="mailto:hello@sensecritiq.com" style={s.colLink}>Contact</a>
              <Link to="/privacy" style={s.colLink}>Privacy</Link>
              <Link to="/terms" style={s.colLink}>Terms</Link>
              <Link to="/cookies" style={s.colLink}>Cookies</Link>
            </div>
          </div>
        </div>
        <div style={s.bottom} className="scq-footer-bottom">
          <span style={s.copy}>© {new Date().getFullYear()} Salvis Are · SenseCritiq. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}

const s = {
  footer: { borderTop:`1px solid ${C.border}`, background:'rgba(3,10,60,0.6)', padding:'60px 48px 32px' },
  inner: {},
  top: { display:'flex', justifyContent:'space-between', gap:48, marginBottom:48 },
  brand: { flexShrink:0 },
  logo: { fontFamily:"'Satoshi','Inter',sans-serif", fontWeight:700, fontSize:17, color:C.muted, letterSpacing:'-0.02em', marginBottom:8 },
  tagline: { fontSize:13, color:C.muted2, lineHeight:1.5, maxWidth:200 },
  cols: { display:'flex', gap:60 },
  col: { display:'flex', flexDirection:'column', gap:12 },
  colHead: { fontSize:11, fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase', color:C.muted2, marginBottom:4 },
  colLink: { fontSize:13, color:C.muted, textDecoration:'none' },
  bottom: { borderTop:`1px solid ${C.border}`, paddingTop:24, textAlign:'center' },
  copy: { fontSize:12, color:C.muted2 },
};
